export class SortColumn {
    readonly PLANNAME : string = "planname";
    readonly PLANYEAR : string = "planyear";
    readonly EINPN : string = "einpn";
    readonly DATERECEIVED: string = "datereceived";
    readonly PLANSPONSER: string = "plansponsor";
    readonly CITYSTATE: string = "citystate";
    readonly PARTICIPANTSBOY: string  = "participantsboy";
    readonly ASSETSEOY: string  = "assetseoy";
}